import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Form, FormMessage, FormControl, OrderFullDecorator, st } from "lib/index";
import OrderCustomerDetailsFormSection from "modules/orders/OrderCustomerDetailsFormSection";

import { stateSelector, updateOrder, validate, submit } from "./index";

@connect(
  (state) => ({
    initialOrder: stateSelector(state).initialOrder,
    order: stateSelector(state).order,
    valid: stateSelector(state).valid,
    submitLoading: stateSelector(state).submitLoading,
    saved: stateSelector(state).saved,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateOrder,
        validate,
        submit,
      },
      dispatch
    )
)
export default class EditOrderCustomerDetailsModalForm extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const { saved, initialOrder, onSave } = this.props;
    if (saved && !prevProps.saved) {
      onSave(initialOrder);
    }
  }

  handleOrderPropChange(prop, value) {
    const { order, updateOrder } = this.props;
    updateOrder(
      new OrderFullDecorator({
        ...order,
        [prop]: value,
      })
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.submit();
  }

  render() {
    const { onCancel, order, errors, valid, submitLoading, updateOrder, validate } = this.props;

    return (
      order && (
        <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
          {!!errors.base && <FormMessage error={errors.base} />}

          <OrderCustomerDetailsFormSection order={order} errors={errors} onChange={updateOrder} onBlur={validate} />

          <button type="submit" disabled={submitLoading} hidden />
        </Form>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/EditOrderCustomerDetailsModal/EditOrderCustomerDetailsModalForm.jsx